import React from "react";
import { BsInstagram, BsYoutube } from "react-icons/bs";

const Footer = () => {
  return (
    <footer className="relative bg-white shadow-[0_-10px_20px_rgba(0,0,0,0.3)]">
      <div className="max-w-6xl mx-auto px-6 py-12 flex flex-col md:flex-row justify-between items-center">
        
        {/* Spacer kiri (supaya konten tengah benar-benar center) */}
        <div className="hidden md:block w-[80px]" />

        {/* Konten tengah */}
        <div className="flex-1 text-center leading-relaxed">
          <div className="flex items-center justify-center gap-2 mb-4">
            <img
              src={require("../Assets/blackobor.png")}
              alt="Smakonecup logo"
              className="h-10 md:h-12 grayscale"
            />
            <h1 className="text-2xl md:text-3xl font-bold text-[#1F211E]">
              Smakonecup
            </h1>
          </div>

         <h4 className="text-base md:text-lg text-[#1F211E] max-w-xl mx-auto mb-4 leading-7">
  Smakonecup Zenith and its logo marks are the property of Smakonecup,
  a part of SMAK 1 PENABUR Jakarta
</h4>

<p className="text-base md:text-lg text-[#1F211E] max-w-2xl mx-auto leading-7">
  Jl. Tanjung Duren Raya No.4, RT.12/RW.2, Tj. Duren Utara,  
  Kec. Grogol Petamburan, Kota Jakarta Barat,  
  Daerah Khusus Ibukota Jakarta 11470
</p>


          <p className="mt-4 text-sm md:text-base text-[#1F211E]">
            Copyright© 2025 Smakonecup Zenith All Rights Reserved
          </p>
        </div>

        {/* Kontak kanan */}
        <div className="flex flex-col items-center justify-center md:items-end mt-12">
          <h2 className="text-lg md:text-xl font-semibold text-[#1F211E] mb-4 text-center md:text-right">
            Contact us
          </h2>
          <div className="flex gap-3">
            <a
              href="https://www.youtube.com/@osissmak1"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              className="text-[#1F211E] hover:opacity-70 transition"
            >
              <BsYoutube size={35} />
            </a>
            <a
              href="https://www.instagram.com/smakonecup/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="text-[#1F211E] hover:opacity-70 transition"
            >
              <BsInstagram size={30} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;